var map = {
	"./Afrique du Sud.png": 6622,
	"./Algérie.png": 9960,
	"./Allemagne.png": 6229,
	"./Arabie Saoudite.png": 2862,
	"./Argentine.png": 2397,
	"./Arménie.png": 3086,
	"./Athlètes Individuels Neutres.png": 2410,
	"./Australie.png": 4129,
	"./Autriche.png": 5595,
	"./Azerbaïdjan.png": 5167,
	"./Bahreïn.png": 2743,
	"./Belgique.png": 4743,
	"./Bolivie.png": 579,
	"./Bosnie-Herzégovine.png": 8008,
	"./Brésil.png": 7004,
	"./Bulgarie.png": 6675,
	"./Burkina Faso.png": 9258,
	"./Cameroun.png": 7304,
	"./Canada.png": 3196,
	"./Chine.png": 4037,
	"./Corée du Sud.png": 3745,
	"./Costa Rica.png": 5584,
	"./Croatie.png": 979,
	"./Cuba.png": 9440,
	"./Danemark.png": 5505,
	"./Djibouti.png": 644,
	"./Espagne.png": 7216,
	"./Estonie.png": 2287,
	"./Fidji.png": 3213,
	"./Finlande.png": 8212,
	"./France.png": 3389,
	"./Gambie.png": 5816,
	"./Grande-Bretagne.png": 6273,
	"./Grèce.png": 9533,
	"./Guatemala.png": 4194,
	"./Guinée-Bissau.png": 3359,
	"./Géorgie.png": 6725,
	"./Hong Kong.png": 1364,
	"./Hongrie.png": 8577,
	"./Inde.png": 8307,
	"./Iran.png": 6937,
	"./Irlande.png": 7049,
	"./Israël.png": 4054,
	"./Italie.png": 5353,
	"./Jamaïque.png": 4261,
	"./Japon.png": 8864,
	"./Kazakhstan.png": 5465,
	"./Kenya.png": 8498,
	"./Kosovo.png": 7314,
	"./Liban.png": 7601,
	"./Lituanie.png": 7971,
	"./Maroc.png": 6123,
	"./Mexique.png": 5293,
	"./Moldavie.png": 5820,
	"./Nigeria.png": 3525,
	"./Norvège.png": 8127,
	"./Nouvelle-Zélande.png": 3344,
	"./Ouganda.png": 7773,
	"./Pakistan.png": 7302,
	"./Pays-Bas.png": 3785,
	"./Philippines.png": 1598,
	"./Pologne.png": 5643,
	"./Porto Rico.png": 8554,
	"./Portugal.png": 4704,
	"./Pérou.png": 6893,
	"./Qatar.png": 3059,
	"./Roumanie.png": 5452,
	"./République Dominicaine.png": 5075,
	"./Samoa.png": 1786,
	"./Serbie.png": 4058,
	"./Singapour.png": 4984,
	"./Slovaquie.png": 2017,
	"./Slovénie.png": 8965,
	"./Suisse.png": 5646,
	"./Suriname.png": 3565,
	"./Suède.png": 5299,
	"./Sénégal.png": 2734,
	"./Taipei Chinois.png": 9675,
	"./Tanzanie.png": 934,
	"./Tchéquie.png": 2756,
	"./Trinité-et-Tobago.png": 3599,
	"./Tunisie.png": 6446,
	"./Turquie.png": 2276,
	"./Ukraine.png": 4668,
	"./Uruguay.png": 8755,
	"./Viêt Nam.png": 5496,
	"./Zimbabwe.png": 2290,
	"./Égypte.png": 2153,
	"./Émirats Arabes Unis.png": 3530,
	"./Équateur.png": 8971,
	"./Équipe Olympique des Réfugiés.png": 5897,
	"./Érythrée.png": 3657,
	"./États-Unis.png": 5604,
	"./Éthiopie.png": 2676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3496;